import script from "./CollectionCommunityActivityTrait.vue?vue&type=script&setup=true&lang=js"
export * from "./CollectionCommunityActivityTrait.vue?vue&type=script&setup=true&lang=js"

import "./CollectionCommunityActivityTrait.vue?vue&type=style&index=0&id=5f7cd043&lang=scss"

const __exports__ = script;

export default __exports__